import { Box, ListItemText, MenuItem, TextField } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setDashboardSearchParameters,
  setSearchAction,
} from "../../redux/reducers/DashboardSlice";
import { useDebounce } from "../../hooks/useDebounce";

function DashboardSearch({ searchText, setSearchText, sortby, setSortBy }) {

  const sortOptions = [
    { value: "all", label: "All" },
    { value: "ledger", label: "Ledger" },
    { value: "group", label: "Group" },
  ]

  const [search, setSearch] = useState(searchText);


  const debouncedChange = useCallback(
    useDebounce((value) => {
      setSearchText(value);
    }, 1000)
  )


  return (
    <Box sx={{ p: "8px", minWidth: { xs: "100px", md: "300px" }, display:"flex",gap:"3px" }}>
      <TextField
        select
        id="profitNLossDate"
        name="profitNLossDate"
        // disabled={params?.view == true ? true : false}
        variant="outlined"
        required={true}
        size="small"
        value={sortby}
        InputLabelProps={{
          shrink: true,
        }}
        onChange={(e) => {
          setSortBy(e.target.value);
        }}
        sx={{
          textAlign: "center",
          height: 35,
          fontSize: 18,
          background: "#ffff",
          borderRadius: "6px",
          border: "none",
          borderRight: "2px solid #cdcde7",
          outline: "none",
          ".MuiOutlinedInput-notchedOutline": {
            border: "none",
            outline: "none",
          },
          ".MuiInputBase-input": {
            color: "black",
            padding: "0px 14px",
          },
          ".MuiSelect-select": {
            height: 35,
            color: "black",
          },
          ".MuiSvgIcon-root": {
            color: "black",
          },
        }}
        inputProps={{ style: { color: "black" } }}
      >
        {sortOptions.map((option, index) => (
          <MenuItem value={option?.value}>
            <ListItemText key={index} primary={option?.label} />
          </MenuItem>
        ))}
      </TextField>
      <TextField
        variant="outlined"
        required={true}
        size="small"
        InputLabelProps={{ shrink: true }}
        value={search}
        sx={{
          textAlign: "center",
          justifyContent: "center",
          width: { xs: 80, sm: 100, md: 250 },
          fontSize: 18,
          height: 35,
          //   boxShadow:
          //     "-4px -4px 4px rgba(255, 255, 255, 0.25), 4px 4px 4px #cdcde7",
          background: "#ffff",
          // borderTopRightRadius: '6px',
          // borderBottomRightRadius: '6px',
          borderRadius: "6px",
          border: "none",
          borderLeft: "2px solid #cdcde7",
          outline: "none",
          ".MuiOutlinedInput-notchedOutline": {
            border: "none",
            outline: "none",
          },
        }}
        placeholder="Search"
        inputProps={{ style: { color: "black" } }}
        onChange={(event) => {
          setSearch(event.target.value);
          debouncedChange(event.target.value);
        }}
      ></TextField>
    </Box>
  );
}

export default DashboardSearch;
